import React from "react";
import MDInput from "materialDashboard/components/MDInput";
import MenuItem from "@mui/material/MenuItem";
import {useTranslation} from "react-i18next";
import WithInfoTooltip from "../../../pages/Model23/Model23Form/WithInfoTooltip";

const CurrentlyActiveSelect = ({value, onChange, ...props}) => {
    const {t} = useTranslation(["inputs", "stations"]);

    const select = (
        <MDInput select
                 value={value ?? ''}
                 onChange={onChange}
                 variant="standard"
                 fullWidth
                 SelectProps={{
                     displayEmpty: true,
                 }}
                 InputLabelProps={{
                     shrink: true,
                 }}
                 label={t("currentlyActiveSelect.label", {ns: "inputs"})}
                 {...props}>
            <MenuItem value="true">{t("currentlyActiveSelect.active", {ns: "inputs"})}</MenuItem>
            <MenuItem value="false">{t("currentlyActiveSelect.inactive", {ns: "inputs"})}</MenuItem>
            <MenuItem value="">{t("currentlyActiveSelect.any", {ns: "inputs"})}</MenuItem>
        </MDInput>
    );

    return (
        <WithInfoTooltip message={t("currentlyActiveSelect.info", {ns: "inputs"})}>
            {select}
        </WithInfoTooltip>
    );
};

export default CurrentlyActiveSelect;
